function init() {

    NetNav.init({});

    //initXYZ();

}

window.addEventListener("load", function () {
    init();
});
